import clear from 'utils/clear';

export const initCountryPicker = (node: HTMLElement, select: HTMLSelectElement) => {
  const icon = node.querySelector<HTMLElement>('[data-icon]')!;

  window.theme.languages.forEach((language) => {
    if (language.country === Shopify.country) return;

    select.insertAdjacentHTML(
      'beforeend',
      `<option value="${language.country}">${language.name} / ${language.currency}</option>`,
    );
  });

  select.addEventListener('change', () => {
    const template = node.querySelector<HTMLTemplateElement>(
      `template[data-country="${select.value}"]`,
    )!;

    if (template) {
      const clone = template.content.cloneNode(true);

      clear(icon);
      icon.appendChild(clone);
    }
  });
};

export default {
  initCountryPicker,
};
